/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationAssignResVo } from './AdminStockAdjustLocationAssignResVo';
import {
    AdminStockAdjustLocationAssignResVoFromJSON,
    AdminStockAdjustLocationAssignResVoFromJSONTyped,
    AdminStockAdjustLocationAssignResVoToJSON,
    AdminStockAdjustLocationAssignResVoToJSONTyped,
} from './AdminStockAdjustLocationAssignResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustLocationAssignResVo
 */
export interface ResponseAdminStockAdjustLocationAssignResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustLocationAssignResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustLocationAssignResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustLocationAssignResVo}
     * @memberof ResponseAdminStockAdjustLocationAssignResVo
     */
    data?: AdminStockAdjustLocationAssignResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustLocationAssignResVo interface.
 */
export function instanceOfResponseAdminStockAdjustLocationAssignResVo(value: object): value is ResponseAdminStockAdjustLocationAssignResVo {
    return true;
}

export function ResponseAdminStockAdjustLocationAssignResVoFromJSON(json: any): ResponseAdminStockAdjustLocationAssignResVo {
    return ResponseAdminStockAdjustLocationAssignResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationAssignResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustLocationAssignResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustLocationAssignResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustLocationAssignResVoToJSON(json: any): ResponseAdminStockAdjustLocationAssignResVo {
    return ResponseAdminStockAdjustLocationAssignResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationAssignResVoToJSONTyped(value?: ResponseAdminStockAdjustLocationAssignResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustLocationAssignResVoToJSON(value['data']),
    };
}

